import { logger } from '@moonpig/web-core-monitoring'

type MixpanelModule = typeof import('mixpanel-browser')

let mixpanelModulePromise: Promise<MixpanelModule['default']> | null = null

const getMixpanel = async (): Promise<MixpanelModule['default']> => {
  if (!mixpanelModulePromise) {
    mixpanelModulePromise = import('mixpanel-browser').then(
      module => module.default,
    )
  }

  return mixpanelModulePromise
}

export const initMixpanel = (
  mixpanelRecordingPercent: number,
  sessionId: string,
  maskAll: boolean,
): Promise<void> => {
  const MIXPANEL_TOKEN = process.env.WEB_PUBLIC_MIXPANEL_TOKEN

  if (!MIXPANEL_TOKEN) {
    logger.warning('Mixpanel token is missing! Check your .env file.')
    return Promise.resolve()
  }

  return getMixpanel().then(mixpanel => {
    mixpanel.init(MIXPANEL_TOKEN, {
      persistence: 'localStorage',
      api_host: 'https://api-eu.mixpanel.com',
      autocapture: false,
      track_pageview: 'full-url',
      record_sessions_percent: mixpanelRecordingPercent,
      record_mask_text_selector: '',
      record_block_selector: '',
      record_mask_all_text: maskAll,
      record_heatmap_data: true,
    })

    mixpanel.register({
      $device_id: sessionId,
    })
  })
}

export const identifyUser = (customerId: string): Promise<void> => {
  return getMixpanel().then(mixpanel => {
    mixpanel.identify(customerId)
  })
}
